'use strict';

var React = require('react');

var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var months = ['January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var DateComponent = React.createClass({
  displayName: 'DateComponent',

  render: function render() {
    return React.createElement(
      'span',
      { className: 'date-component' },
      this._formatDate(this.props.children, this.props.format || 'HH:MM:SS ddd dd mmm yyyy')
    );
  },

  _formatDate: function _formatDate(date, format) {
    var _this = this;

    return format.replace(/(\w)\1+|(\w)/gi, function (found) {
      return _this._replace(found, date);
    });
  },

  _replace: function _replace(str, date) {
    switch (str) {
      case 'S':
        return date.getSeconds();
      case 'SS':
        return (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
      case 'M':
        return date.getMinutes();
      case 'MM':
        return (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
      case 'H':
        return date.getHours();
      case 'HH':
        return (date.getHours() < 10 ? '0' : '') + date.getHours();
      case 'dddd':
        return weekdays[date.getDay()];
      case 'ddd':
        return weekdays[date.getDay()].substring(0, 3);
      case 'dd':
        return (date.getDate() < 10 ? '0' : '') + date.getDate();
      case 'm':
        return date.getMonth() + 1;
      case 'mm':
        return (date.getMonth() < 11 ? '0' : '') + date.getMonth() + 1;
      case 'mmm':
        return months[date.getMonth()].substring(0, 3);
      case 'mmmm':
        return months[date.getMonth()];
      case 'y':
        return date.getFullYear().toString().substring(3);
      case 'yy':
        return date.getFullYear().toString().substring(2);
      case 'yyy':
        return date.getFullYear().toString().substring(1);
      case 'yyyy':
        return date.getFullYear().toString();
    }
  }
});

module.exports = DateComponent;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/date.js
 **/